export enum ReviewsAction {
  GET_REVIEWS_LIST_SUCCESS = 'GET_REVIEWS_LIST_SUCCESS',
  GET_REVIEWS_TOTALS_SUCCESS = 'GET_REVIEWS_TOTALS_SUCCESS',
  DELETE_REVIEW_ITEM_SUCCESS = 'DELETE_REVIEW_ITEM_SUCCESS',
  EDIT_REVIEW_ITEM_SUCCESS = 'EDIT_REVIEW_ITEM_SUCCESS',
  SET_REVIEWS_FREELANCERS_FILTERS_DATA = 'SET_REVIEWS_FREELANCERS_FILTERS_DATA',
  SET_REVIEWS_CLIENTS_FILTERS_DATA = 'SET_REVIEWS_CLIENTS_FILTERS_DATA',
  STOP_REVIEWS_LOADING = 'STOP_REVIEWS_LOADING',
}
